import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './ReusablePortal.scss';
interface IPortalProps {
	children: ReactNode;
	position: 'bottom';
	className: string;
	portalId: 'hub-portal';
}

export const ReusablePortal: React.FC<IPortalProps> = ({
	children,
	className,
	position = 'bottom',
	portalId
}) => {
	const [mounted, setMounted] = useState<boolean>(false);
	useEffect(() => {
		setMounted(true);
		let portalRoot = document.getElementById(portalId);
		if (!portalRoot) {
			portalRoot = document.createElement('div');
			portalRoot.id = portalId;
			document.body.appendChild(portalRoot);
		}
		return () => {
			if (portalRoot && portalRoot.childNodes.length === 0) {
				document.body.removeChild(portalRoot);
			}
		};
	}, [portalId]);
	if (!mounted) return null;
	const target = document.getElementById(portalId);
	if (!target) return null;

	return createPortal(<div className={className + ' ' + position}>{children}</div>, target);
};
